<template>
  <v-chip label :size="size" :disabled="disabled">
    <v-icon left :size="size" class="pr-1"> {{ icon }} </v-icon>
    {{ revision ? revision.name : null }}
  </v-chip>
</template>
<script>
export default {
  name: 'RevisionChip',
  props: {
    revision: { required: true },
    size: { required: false, default: 'small' },
    disabled: { required: false, default: false },
    icon: { required: false, default: 'mdi-rotate-right' }
  }
}
</script>
